/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { Tag } from 'lucide-react';

export const AvailabilityCheckIndicator = ({ message }) => (
  <motion.div
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 'auto' }}
    className="p-4 bg-blue-50 border border-blue-200 rounded-xl"
  >
    <div className="flex items-center text-blue-700">
      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-700 mr-2"></div>
      <span className="text-sm font-medium">{message}</span>
    </div>
  </motion.div>
);

export const DiscountCheckIndicator = () => (
  <motion.div
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 'auto' }}
    className="p-4 bg-purple-50 border border-purple-200 rounded-xl"
  >
    <div className="flex items-center text-purple-700">
      <Tag className="w-4 h-4 mr-2 animate-pulse" />
      <span className="text-sm font-medium">Checking for eligible discounts...</span>
    </div>
  </motion.div>
);